import { HttpModelConverter } from "../../../../../../../core/converter/httpModel.converter";
import { Injectable } from "@angular/core";
import { PaymentRequestReminderModel } from "../paymentRequestReminder.model";
import { PaymentRequestReminderSummaryConverter } from "./paymentRequestReminderSummary.converter";
import { WorkflowTaskSummaryConverter } from "../../../../../../../workflow/task/api/model/common/converter/workflowTaskSummary.converter";

@Injectable()
export class PaymentRequestReminderConverter extends HttpModelConverter<PaymentRequestReminderModel> {

    constructor(private summaryConverter: PaymentRequestReminderSummaryConverter,
        private workflowTaskSummaryConverter: WorkflowTaskSummaryConverter) {
        super();
    }

    protected createInstance(): PaymentRequestReminderModel {
        return new PaymentRequestReminderModel();
    }

    protected enrichObject(result: PaymentRequestReminderModel, src: PaymentRequestReminderModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.workflowTasks = this.workflowTaskSummaryConverter.convertFromArray(src.workflowTasks);
    }


}
